import React, { Component } from "react";

class PrivacyPolicyV3 extends Component {
  renderSection = (section, index) => {
    return (
      <div key={index} className="mb-4">
        {section.heading && (
          <h3 className="mt-4 mb-3">{section.heading}</h3>
        )}

        {section.content && (
          <p
  style={{ whiteSpace: "pre-line" }}
  dangerouslySetInnerHTML={{ __html: section.content }}
/>
        )}

        {section.list && (
          <ul className="mt-3">
            {section.list.map((item, i) => (
              <li key={i} className="mb-2">
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  render() {
    const privacyPolicy = [
      {
        heading: "Privacy Policy and Legal Notice",
        content: `<h5>Atom Power Pvt. Ltd.</h5>`,
      },
      {
        heading: "Personal Information",
        content: `Atom Power Pvt. Ltd. recognizes the importance of securing the privacy of data we may gather from you.

The reason behind this strategy is to inform you how we handle data we may collect about you from your visit to our site, engaging with our content, or otherwise how Atom Power handles personal information regarding you.

Any personal data provided to us will be treated with the highest standards of security and confidentiality, and our privacy policies follow applicable laws.`,
      },
      {
        heading: "Information/Data We Collect on This Website",
        content: `Data collection is done through forms for subscription.

Atom Power collects data from you when you download a brochure, subscribe to newsletters or blogs, or fill in any form on the website for product-related information.

We gather your email address (as the primary source of contact), name, and other information such as organization name and industry.

We only use this information to update you with the information you requested or to send marketing communications if you have opted in.

We store and use this data only as long as necessary to manage your subscription, respond to inquiries, or provide requested materials.`,
      },
      {
  heading: "Information/Data We Collect with Cookies",
  content: `This site uses cookies. Cookies are small text files stored in your browser when you visit a site and can be retrieved on later visits.

You will see a consent pop-up when visiting our site. You can choose not to allow cookies, but this may affect your experience. You can also manage cookies via your browser settings.

Most browsers allow some control of cookies; for more information, visit 
<a  href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">www.aboutcookies.org</a> or <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a>.

We use cookies for:`,
  list: [
    "Session cookies to monitor and save page language",
    "Analyzing site usage and improving visitor experience",
    "Enhancing and customizing content based on device or browser type",
    "Evaluating content use and search terms",
  ],
},
      {
        content: `Cookies may collect: IP address, browser type, referring pages, page response times, downloaded material, length of visits, and page interaction data. Data is stored for a maximum of 26 months and then deleted.`,
      },
      {
        heading: "Data Gathered by Other Means",
      },
      {
        heading: "For Sales Purposes",
        content: `If you have been contacted regarding Atom Power products and have agreed to further contact, we collect personal information such as name, contact details, organization, and position.

We use this data only for marketing and brand-related purposes and retain it for a maximum of two years.

You can withdraw consent or opt out of marketing messages at any time.

Contact us at: <strong>info@atom-power.com</strong> for questions about how we process personal data.`,
      },
      {
        heading: "Data About Contacts at Clients, Providers, and Partners",
        content: `If you work at an organization that interacts with Atom Power, and you are a contact person, we collect information necessary to fulfill our contractual and legal obligations.

We process this data for the duration of the agreement, up to a maximum of five years if longer retention is not required by law.

You may withdraw consent or opt out of marketing communications at any time.`,
      },
      {
        heading: "Third-Party Data Sharing",
        content: `Atom Power only shares data as described in this policy. We do not sell your personal information.

We may share data with trusted third-party service providers, including Google for Analytics, or where required by law. Third-party transfers outside the country will ensure adequate data protection levels.`,
      },
      {
        heading: "Website Links",
        content: `Atom Power may provide links to other websites. We are not responsible for the content, actions, or policies of third-party sites.`,
      },
      {
        heading: "Your Rights",
      },
      {
        heading: "General Rights",
        list: [
          "Opt out of marketing communications anytime via unsubscribe links or contacting us",
          "Request deletion of your personal data (with legal/operational exceptions)",
        ],
      },
      {
        heading: "Users from the European Economic Area",
        list: [
          "Object to processing of personal data, including profiling",
          "Access, correct, or request deletion of personal data",
          "Restrict processing under certain conditions",
          "Withdraw consent for cookie tracking",
          "Complain to local data protection authorities",
        ],
      },
      {
        content:
          "We may request information to verify your identity when implementing rights.",
      },
      {
        heading: "Legal Notice",
        content: `This website may contain other legal notices and copyright information. All images are the property of Atom Power and may not be copied without permission.

Information may be changed without notice. Atom Power is not responsible for the accuracy of information or any use thereof. Submission of materials does not grant Atom Power licenses, except for rights explicitly stated.`,
      },
      {
        heading: "Data Protection Officer (DPO) Contact",
        content: `For GDPR-related questions:
<strong>Email</strong>: info@atom-power.com`,
      },
     
    ];

    return (
      <div className="ltn__faq-area mb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__faq-inner ltn__faq-inner-2">
                {privacyPolicy.map(this.renderSection)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicyV3;